export { default } from "./SquareCollection";
